import React from "react";
import TextField from "@mui/material/TextField";


function TextFieldRenderer(props) {
  const config = props.field?.config || {};
  const rows = typeof config.rows === "number" ? config.rows : 4;
  const placeholder = typeof config.placeholder === "string" ? config.placeholder : "";

  const text = props.value && typeof props.value.text === "string" ? props.value.text : "";

  const handleChange = (evt) => {
    const newText = evt.target.value;
    if (newText.length === 0) {
      props.onChange(null);
    } else {
      props.onChange({ text: newText });
    }
  };

  return (
    <TextField
      multiline
      rows={rows}
      fullWidth
      variant="outlined"
      size="small"
      value={text}
      placeholder={placeholder}
      onChange={handleChange}
      disabled={props.disabled}
      InputProps={{
        sx: {
          backgroundColor: "white",
          borderRadius: "8px",
          fontSize: "14px",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6d28d9",
          },
        },
      }}
    />
  );
}

export default TextFieldRenderer;
